import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import { processDate } from 'utils/helpers/functions';
import styles from 'sections/Resources/BillOfLading/components/SectionRelatedPosts/Post/Post.module.scss';

const cn = classNames.bind(styles);

interface Post {
  id: number;
  title: string;
  tag: string;
  date: string;
  url: string;
  image: string;
};

const Post: FC<Post> = ({ id, title, tag, date, url, image }): ReactElement => {
  return (
    <li key={id} className={cn('post')}>
      <Link className={cn('post__link')} href={`/blog/${url}`} >
        <div className={cn('post__image-box')}>
          <img
            className={cn('post__image')}
            src={image}
            width="374"
            height="184"
            alt="Blog 1" loading="lazy" />
        </div>
        <div className={cn('post__content')}>
          <div className={cn('post__info')}>
            <span className="rubric">{tag}</span>
            <svg
              width="4"
              height="5"
              viewBox="0 0 4 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <circle cx="2" cy="2.74219" r="2" fill="white" />
            </svg>
            <span className={cn('post__date')}>{processDate(date)}</span>
          </div>
          <h4 className={cn('post__title')}>{title}</h4>
        </div>
      </Link>
    </li>
  );
};

export { Post };